import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { retrieveMilestoneError } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return (milestoneId) =>
    present(
      repository.getMilestone(milestoneId).catch((error) =>
        Promise.reject({
          error: { ...retrieveMilestoneError, ...error },
          milestoneId,
        }),
      ),
    );
}

export type { Interactor };

export { createInteractor };
